var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "checkout-review-basket-page-container" }, [
      _c("section", { staticClass: "text-center bg-white main-heading-page" }, [
        _c("h2", [
          _vm._v(_vm._s(_vm.$resourceString["checkout.Title.ReviewBasket"]))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row align-items-start" }, [
          _c("div", { staticClass: "col-12 col-lg-8 col-xl-9" }, [
            _c("div", { staticClass: "checkout-review-basket-page-wrap" }, [
              _c(
                "div",
                {
                  staticClass:
                    "checkout-review-basket-page-details-row checkout-review-details-shipping"
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c(
                        "h5",
                        { staticClass: "primary-heading font-weight-bold" },
                        [
                          _vm._v(
                            "\n                                        " +
                              _vm._s(
                                _vm.$resourceString[
                                  "checkout.ReviewBasket.Title.Shipping"
                                ]
                              ) +
                              "                                           \n                                        "
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "edit-btn",
                              attrs: { type: "button" },
                              on: { click: _vm.shippingEditHandler }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$resourceString["common.Label.Edit"])
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-5 col-sm-6 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "checkout-review-details-col" },
                        [
                          _c("div", { staticClass: "details-label-heading" }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.Shipping.Label.ShipTo"
                                  ]
                                ) + ":"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details-body" }, [
                            _vm.getCurrentAddressIndex
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "details-body-shipping-address"
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.currentAddress.firstName) +
                                          " " +
                                          _vm._s(_vm.currentAddress.lastName)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        "\n                                                    " +
                                          _vm._s(
                                            _vm.currentAddress.streetLine2
                                              ? _vm.currentAddress.streetLine1 +
                                                  ", Suite" +
                                                  _vm.currentAddress.streetLine2
                                              : _vm.currentAddress.streetLine1
                                          ) +
                                          ".\n                                                "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.currentAddress.city) +
                                          ", " +
                                          _vm._s(_vm.currentAddress.state) +
                                          ", " +
                                          _vm._s(
                                            _vm.currentAddress.postalCode
                                          ) +
                                          ", " +
                                          _vm._s(_vm.currentAddress.country) +
                                          "."
                                      )
                                    ])
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass: "details-body-shipping-address"
                                  },
                                  [_c("span", [_vm._v("N/A")])]
                                )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-7 col-sm-6 col-12" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "checkout-review-details-col checkout-review-shipping-option-details"
                        },
                        [
                          _c("div", { staticClass: "details-label-heading" }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.Shipping.Label.ShippingOptions"
                                  ]
                                ) + ":"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details-body" }, [
                            _vm.checkoutData.ShippingOption
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "checkout-review-shipping-options-list"
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getShippingOptionName(
                                            _vm.checkoutData.ShippingOption
                                          ).title || "N/A"
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getShippingOptionName(
                                            _vm.checkoutData.ShippingOption
                                          ).description || "N/A"
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "checkout-review-basket-page-details-row checkout-review-details-shipping"
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c(
                        "h5",
                        { staticClass: "primary-heading font-weight-bold" },
                        [
                          _vm._v(
                            "\n                                        " +
                              _vm._s(
                                _vm.$resourceString[
                                  "checkout.ProjectInformation.Title.MainHeading"
                                ]
                              ) +
                              " \n                                        "
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "edit-btn",
                              attrs: { type: "button" },
                              on: { click: _vm.projectInfoEditHandler }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$resourceString["common.Label.Edit"])
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        { staticClass: "checkout-review-details-col" },
                        [
                          _c("div", { staticClass: "details-label-heading" }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.ProjectInformation.Label.ProjectName"
                                  ]
                                ) + ":"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details-body" }, [
                            _c(
                              "div",
                              { staticClass: "details-body-shipping-address" },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      this.checkoutData.ProjectName || "N/A"
                                    )
                                  )
                                ])
                              ]
                            )
                          ])
                        ]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "checkout-review-basket-page-details-row checkout-review-details-shipping"
                },
                _vm._l(Object.keys(_vm.checkoutItemList), function(list) {
                  return _vm.checkoutItemList[list].length > 0
                    ? _c("div", { key: list }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c(
                              "h5",
                              {
                                staticClass: "primary-heading font-weight-bold"
                              },
                              [
                                list.toLowerCase() === "siteitems"
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$resourceString[
                                            "myBasket.Label.IndividualSamples"
                                          ]
                                        ) +
                                          " : " +
                                          _vm._s(
                                            _vm.checkoutItemCount.siteItems
                                          )
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                list.toLowerCase() === "projectitems"
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$resourceString[
                                            "myBasket.Label.ProjectSamples"
                                          ]
                                        ) +
                                          " : " +
                                          _vm._s(
                                            _vm.checkoutItemCount.projectItems
                                          )
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                list.toLowerCase() === "trayitems"
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$resourceString[
                                            "myBasket.Label.DesignTraySample"
                                          ]
                                        ) +
                                          " : " +
                                          _vm._s(
                                            _vm.checkoutItemCount.trayItems
                                          )
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "edit-btn",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.productSampleEditHandler(
                                          list
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$resourceString["common.Label.Edit"]
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c(
                              "div",
                              { staticClass: "checkout-review-details-col" },
                              [
                                _c("basket-item", {
                                  attrs: {
                                    listItems: _vm.checkoutItemList[list],
                                    listName:
                                      list.toLowerCase() ===
                                      _vm.siteItems.toLowerCase()
                                        ? _vm.siteItems
                                        : list.toLowerCase() ===
                                          _vm.projectItems.toLowerCase()
                                        ? _vm.projectItems
                                        : list.toLowerCase() ===
                                          _vm.trayItems.toLowerCase()
                                        ? _vm.trayItems
                                        : "",
                                    isCheckoutPage: true,
                                    isClearAll: false
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      ])
                    : _vm._e()
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-12 col-lg-4 col-xl-3 sidebar-position-sticky sidebar-mobile-device"
            },
            [
              _c("div", { staticClass: "checkout-basket-sidebar-warpper" }, [
                _c(
                  "div",
                  { staticClass: "checkout-basket-sidebar-container" },
                  [
                    _c("pc-basket-sidebar", {
                      attrs: {
                        individualSamples:
                          _vm.checkoutItemList.siteItems.length > 0,
                        individualSamplesCount: _vm.checkoutItemCount.siteItems,
                        projectSamples:
                          _vm.checkoutItemList.projectItems.length > 0,
                        projectSamplesCount: _vm.checkoutItemCount.projectItems,
                        designTraySample:
                          _vm.checkoutItemList.trayItems.length > 0,
                        designTraySampleCount: _vm.checkoutItemCount.trayItems,
                        backLabel:
                          _vm.$resourceString["checkout.Button.BackToProject"],
                        backAction: _vm.backHandler,
                        nextLabel:
                          _vm.$resourceString[
                            "checkout.Button.SubmitSampleOrder"
                          ],
                        nextAction: _vm.continueToCheckoutHandler,
                        isNextDisabled: _vm.OrderSampleEnabled,
                        isError: _vm.isErrorForSideBar(),
                        errorMsg: _vm.errorMsgForSideBar()
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }